import { ArrowLeft } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import backgroundMobile from 'src/assets/mobileBackground.png'
import appStore from 'src/assets/product-config/app-store.png'
import android from 'src/assets/product-config/google-play.png'
import hit from 'src/assets/product-config/hit.png'
import wingDollar from 'src/assets/product-config/wing-dollar.png'
import wingDollars from 'src/assets/product-config/wing-dollars.png'
import './styles.css'

export const WhyCreateWallet = () => {
  const navigate = useNavigate()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 720)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  if (isMobile) {
    return (
      <div
        className="w-full h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundMobile}')`,
        }}
      />
    )
  }

  return (
    <div className="flex relative items-center flex-col w-full h-screen p-24">
      <img
        alt=""
        src={wingDollar}
        className="w-[100px] xl:w-[200px] 2xl:w-[250px] xl:left-15 xl:bottom-15 object-contain absolute left-10 bottom-10"
      />
      <img
        alt=""
        src={hit}
        className="w-[20px] xl:w-[30px] 2xl:w-[40px] xl:right-32 xl:top-32 object-contain absolute right-20 top-20"
      />
      <img
        alt=""
        src={wingDollars}
        className="w-[200px] xl:w-[300px] 2xl:w-[400px] xl:right-15 xl:bottom-15 object-contain absolute right-10 bottom-10"
      />
      <div className="flex flex-col  xl:w-[1200px] ">
        <div className="flex gap-8">
          <button
            onClick={() => navigate('/signin')}
            className="h-12 w-12 flex items-center justify-center rounded-xl bg-zinc-950 shadow-sm"
          >
            <ArrowLeft size={22} color="white" />
          </button>
          <h1 className="text-5xl text-zinc-950 font-semibold">
            Por que abrir uma wallet?
          </h1>
        </div>
        <div className="flex flex-col pl-20 mt-8 gap-6">
          <span className="2xl:text-xl text-lg">
            Os bancos digitais revolucionaram a forma como lidamos com o
            dinheiro, trazendo mais praticidade,
            <br /> agilidade e economia. E uma das inovações mais vantajosas é a
            Conta Wallet – uma carteira digital que
            <br /> facilita ainda mais o seu dia a dia financeiro.
          </span>
          <span className="2xl:text-xl text-lg">
            Com uma Conta Wallet, você tem acesso instantâneo ao seu dinheiro
            pelo celular, sem burocracia.
            <br /> Esqueça filas e papelada – tudo pode ser feito de forma
            rápida e segura.
          </span>
          <span className="2xl:text-xl text-lg">
            Se você busca mais liberdade, economia e praticidade na sua vida
            financeira, uma Conta Wallet é a<br /> melhor escolha. Experimente
            essa inovação e aproveite todas as vantagens da era digital!
          </span>
          <button
            onClick={() =>
              navigate('/create-account-wallet/choose-account-type')
            }
            className="mt-14 h-12 w-[350px] flex items-center justify-center rounded-md bg-zinc-950 shadow-sm"
          >
            <span className="text-white font-medium">
              Quero abrir uma conta
            </span>
          </button>
          <div className="flex flex-col mt-10">
            <span className="text-zinc-950 font-bold text-lg">
              Baixe o nosso app,
            </span>
            <span className="text-zinc-950 font-medium text-lg">
              disponível nas principais lojas
            </span>
            <div className="flex gap-2 mt-2">
              <img
                alt=""
                src={android}
                className="w-[150px] object-contain cursor-pointer invert"
              />
              <img
                alt=""
                src={appStore}
                className="w-[150px] object-contain cursor-pointer invert"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
